module.exports = __webpack_public_path__ + "static/media/register.1ff7e754.png";